<template>
  <div class="animated fadeIn pa-dashboard">
    <b-row class="justify-content-center">
      <b-col md="12" sm="12">
        <b-card no-body>
          <b-card-header>
            <b-row class="ml-1 mt-1 mr-1">
              <b-col sm="8" class="justify-content-center">
                <b-form-group
                  label-cols-sm="3"
                  label-class="font-weight-bold pt-0"
                  label="Selected Rows:"
                >
                  <b-form-checkbox-group
                    id="selected"
                    name="selectedFields"
                    v-model="rows"
                    :options="fieldOptions"
                  ></b-form-checkbox-group>
                </b-form-group>
              </b-col>
              <b-col sm="4" class="justify-content-center">
                <b-form-group
                  label-cols-sm="3"
                  label-class="font-weight-bold pt-0"
                  label="Date Range:"
                >
                  <date-picker
                    v-model="selectedRange"
                    class="form-control"
                    type="date"
                    :not-after="new Date()"
                    lang="en"
                    range
                    :shortcuts="rangeShortcut"
                    format="YYYY-MM-DD"
                    range-separator="thru"
                    @confirm="search"
                    :confirm="true"
                  ></date-picker>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12"></b-col>
            </b-row>
          </b-card-header>
          <b-card-body class="p-6">
            <vue-pivottable
              :data="pivotData"
              :aggregator-name="aggregatorName"
              :renderer-name="rendererName"
              :rows="rows"
              :cols="cols"
              :vals="vals"
              :row-total="true"
              :col-total="true"
            ></vue-pivottable>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { VuePivottable } from "vue-pivottable";
import { mapState } from "vuex";
import { PA_HISTORY_SEARCH_METRICS } from "@/store/pa/actions.type";
import "vue-pivottable/dist/vue-pivottable.css";

const statusMap = {
  CommunicationFailure: 1,
  PAApproved: 2,
  PACanceled: 3,
  PADenied: 4,
  SentFAX: 5,
  SentEDI: 6,
  ErrorPortal: 7,
  EHRError: 8,
  Pending: 9,
  MissingData: 10
};
export default {
  name: "PADashboard",
  components: { VuePivottable, DatePicker },
  data() {
    return {
      aggregatorName: "Integer Sum",
      rendererName: "Table",
      rows: ["Client", "Drug", "NDC"],
      cols: ["Status"],
      vals: ["Count"],
      disabledFromDragDrop: ["Count"],
      hiddenFromDragDrop: ["Count"],
      fieldOptions: ["Client", "Drug", "NDC", "Reject Code"],
      selectedRange: [getStartDate(), getEndDate()],
      rangeShortcut: [
        {
          text: "previous 30 days",
          onClick: () => {
            let d = new Date();
            d.setDate(d.getDate() - 30);
            d.setHours(0, 0, 0, 0);
            this.selectedRange = [d, getEndDate()];
          }
        }
      ]
    };
  },
  computed: {
    pivotData() {
      let mappedData = [];
      if (this.searchMetricsResults) {
        const statuses = this.searchMetricsResults
          .map(x => x.status)
          .reduce((aggr, current) => {
            aggr[current] = current;
            return aggr;
          }, {});
        const statusArray = Object.keys(statuses);
        statusArray.sort((a, b) => {
          return statusMap[a] - statusMap[b];
        });

        mappedData = this.searchMetricsResults.map(el => {
          var client = this.capitalize(el.client || el.source);
          var row = [
            client,
            el.drug_short_name,
            el.drug_ndc,
            el.reject_code,
            this.mapStatus(el.status, statusArray),
            el.doc_count
          ];
          return row;
        });
      }
      mappedData.unshift([
        "Client",
        "Drug",
        "NDC",
        "Reject Code",
        "Status",
        "Count"
      ]);
      return mappedData;
    },
    ...mapState({
      searchMetricsResults: state => state.pa.searchMetricsResults.records
    })
  },
  created: function() {
    this.search();
  },
  methods: {
    search() {
      if (!this.$store.state.pa.isSearchBusy) {
        this.$store.dispatch(PA_HISTORY_SEARCH_METRICS, this.getCriteria());
      }
    },
    mapStatus(status, statuses) {
      return statusMap[status]
        ? `${statuses.indexOf(status) + 1} - ${status}`
        : status;
    },
    capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    getCriteria() {
      this.selectedRange[0].setHours(0, 0, 0, 0);
      this.selectedRange[1].setHours(23, 59, 59, 999);

      let criteria = {
        StartDate: new Date(this.selectedRange[0].toUTCString()).toISOString(),
        EndDate: new Date(this.selectedRange[1].toUTCString()).toISOString(),
        Statuses: ["Sent", "ResponseReceived", "ResponseFailure"]
      };
      return criteria;
    }
  }
};

function getStartDate() {
  let startDate = new Date();
  startDate.setDate(startDate.getDate() - 30);
  startDate.setHours(0, 0, 0, 0);
  return startDate;
}

function getEndDate() {
  let endDate = new Date();
  endDate.setHours(23, 59, 59, 999);
  return endDate;
}
</script>
<style lang="scss" scoped>
.pa-dashboard {
  padding: 50px;
  .pvtTable {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PADashboard.vue